import { render, staticRenderFns } from "./BookExchangeTabsComponent.vue?vue&type=template&id=29fb1d39&scoped=true&"
import script from "./BookExchangeTabsComponent.vue?vue&type=script&lang=js&"
export * from "./BookExchangeTabsComponent.vue?vue&type=script&lang=js&"
import style0 from "./BookExchangeTabsComponent.vue?vue&type=style&index=0&id=29fb1d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb1d39",
  null
  
)

component.options.__file = "BookExchangeTabsComponent.vue"
export default component.exports